// extracted by mini-css-extract-plugin
module.exports = {"landing_page_F":"F_landing_page_F__13hd4"};